<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Payroll 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="process_Confirm=true">Process</b-button>
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()">Print Slip</b-button>
          <b-button variant="primary mr-1" @click="email()">Email Slip</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7">
            <b-row>
              <b-col lg="6">
                    <b-input-group>
                      <b-input-group-prepend><label>Payroll Date</label></b-input-group-prepend>
                      <vue-monthly-picker style="width:300px;" v-model="tblData.paymentdate" dateFormat="MMMM YYYY" :monthLabels="monthLabels"></vue-monthly-picker>
                    </b-input-group>
              </b-col>
              <b-col lg="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Project</label></b-input-group-prepend>
                        <b-form-input readonly v-model="tblData.projectname" ></b-form-input>
                        <b-input-group-append>
                            <b-btn text="Button" @click="lkuCustomerShow=true" ><i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>
              </b-col>
            </b-row>            
            <b-row>
              <b-col  lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.departemen" placeholder="Departmenet Name"></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.golongan" ></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>            
            <b-row>
              <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.jabatan" placeholder="Job Title"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Job Position</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.pangkat" placeholder="Position Name"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>            
        </b-col>
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><label>Employee </label></b-input-group-prepend>
                <b-form-input v-model="tblData.crewname" placeholder="Name" class="mr-1" style="width:40% !important;"></b-form-input>
                <b-form-input v-model="tblData.crewnik" placeholder="ID Number"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Shift/Non Shift</label></b-input-group-prepend>
                <b-form-select v-model="tblData.officer" :plain="true" :options="officerStatus"></b-form-select>
                <b-input-group-append><label class="pt-2">&nbsp; Active &nbsp;</label></b-input-group-append>
                <b-form-select v-model="tblData.terminate" :plain="true" :options="activeStatus"></b-form-select>
            </b-input-group>
          <b-input-group >
            <b-input-group-prepend><label >&nbsp;</label></b-input-group-prepend>
            <b-input-group-append>
                <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>        
      </b-row>                      
          <b-table
            class="mb-0 text-nowrap"
            ref="tblEmployee"
            responsive
            striped hover 
            style="font-size:smaller;" 
            show-empty
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectEmployee"
          >
          <template v-slot:cell(payrolldate)="data">
            <span v-if="(data.item.payrolldate)">{{ data.item.payrolldate | moment("DD-MMM-YYYY") }}</span>
          </template>
          <template v-slot:cell(overtimeable)="data">
            <span v-if="(data.item.overtimeable==1)">Eligible</span>
            <span v-else>No</span>
          </template>
          <template v-slot:cell(takehomepay)="data">
          {{data.item.takehomepay|numFormat}}
          </template>
        </b-table>

        <b-row class="mt-1">
          <b-col cols="4">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
          </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 15, 20, 25, 30, 35,40,45,50]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
              <b-pagination
                align="right"
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
        </b-col>
        </b-row>
    </b-card>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
          <p class="mb-1">1 record is about to be permanently deleted</p>
          <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
        </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Client/Project" :centered="true">
        <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>        
    <b-modal v-model="process_Confirm" title="Process Payroll" :centered="true" header-bg-variant="primary" hide-footer>
              <b-row>
                <b-col lg="8">
                  <b-input-group>
                    <b-input-group-prepend><label>Payroll Date</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.payrolldate" type='date'></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>

            <div style="text-align:right; display:blocked" class="mt-3" >
                <b-button variant="success" @click="payrollprocess"><i class="fa fa-play"></i> Process Payroll</b-button>
                <b-button variant="danger" class="ml-1" @click="payrollcancel" > <i class="fa fa-undo"></i> Cancel Payroll</b-button>
                <b-button variant="secondary" class="ml-1" @click="process_Confirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </div>
    </b-modal>

  </div>
</template>
<style lang="scss">
    .input-group {
        .input-group-prepend {
          padding-bottom:2px;
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
   iframe {
        border: 1px solid #ccc;
        width: 100%;
        height: 11in;
    }    
</style>
<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from 'moment';
import lkuCustomer from "../lookup/lkuCustomers";
import payroll from "../../apis/payroll";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  components :{Loading, lkuCustomer, VueMonthlyPicker},
  mixins: [validationMixin],
  validations: {
        frmdata: {
          payrolldate: { required }
        }
  }, 
  data() {
    return {
      fields: [
          { key: "crewnik" , 
            label: "Employee ID",
            thStyle: "width:100px",
            sortable: true
          },
          { key: "crewname" , 
            label: "Employee Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
            thStyle: "width:150px",
          },
          {
            key: "departemen",
            label: "Department",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Client/Project",
            sortable: true
          },
         {
            key: "payrolldate",
            thStyle: "width:90px",
            label: "Payroll Date",
            sortable: true
          },

          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "takehomepay",
            thStyle: "width:100px",
            label: "Take Home Pay",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "bankaccno",
            thStyle: "width:150px",
            label: "Bank Account"
          },
          {
            key: "bankname",
            thStyle: "width:150px",
            label: "Bank Name"
          },
          {
            key: "HARI_HADIR",
            thStyle: "width:50px",
            label: "Hadir",
            sortable: true
          },
          {
            key: "HARI_SAKIT",
            thStyle: "width:50px",
            label: "Sakit",
            sortable: true
          },
          {
            key: "HARI_IZIN",
            thStyle: "width:50px",
            label: "Izin",
            sortable: true
          },
          {
            key: "HARI_ALPA",
            thStyle: "width:50px",
            label: "Alpa",
            sortable: true
          },
          {
            key: "HARI_BKO",
            thStyle: "width:30px",
            label: "BKO",
            sortable: true
          },
          {
            key: "HARI_OOT",
            thStyle: "width:30px",
            label: "OOT",
            sortable: true
          },
          {
            key: "overtimeable",
            thStyle: "width:40px",
            label: "OverTime",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "INDEX_OT",
            thStyle: "width:50px",
            label: "INDEX OT",
            sortable: true
          },
          {
            key: "HARI_MAHAL",
            thStyle: "width:50px",
            label: "TJ. MAHAL",
            sortable: true
          },
      ],
      pagination:false,
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false, terminate:'0'
      },
      model:{},
      monthLabels:dropdown.monthLabels,
      frmdata:{payrolldate:'', tahunbulan:''},
      process_Confirm:false,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      lkuCustomerShow:false,
      showImgTool:false,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
        activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Yes' },{ value: '1', text: 'No' }],
        officerStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Shift/Scheduled Worker' },{ value: '1', text: 'Office/Daily Worker' }],

    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    onSelectLkuCustomer: async function (_selected) {
        this.tblData.projectname = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
        this.tblData.projectid = _selected.customer_id;
        this.lkuCustomerShow=false;
    },
    selectEmployee(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.pyrllist) {
            this.tblData[key] = filter.pyrllist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.pyrllist.tgl1 || '';
          this.tblData.tgl2=filter.pyrllist.tgl2 || '';

          this.showFilter=filtered;
          delete filter.pyrllist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await payroll.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await payroll.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    refresh() {
      this.$refs.tblEmployee.refresh();
    },
    clearFilter(ctx) {
        this.tblData.crewcode = '';
        this.tblData.crewname =  '';
        this.tblData.departemen = '';
        this.tblData.golongan =  '';
        this.tblData.group = '';
        this.tblData.officer = '';
        this.tblData.terminate = '';
        this.tblData.projectid = '';
        this.tblData.projectname = '';
        this.tblData.paymentdate = '';
        // this.refresh();
    },    
    saveFilter() {
      const keys = ['compcode', 'crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'payrolldate','tahunbulan', 'terminate', 'officer', 'projectid', 'projectname'];
      let filtered = false;
      const pyrllist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              pyrllist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          pyrllist.page=this.tblData.page;
          pyrllist.limit=this.tblData.limit;
          pyrllist.sortBy=this.tblData.sortBy;
          pyrllist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.pyrllist=pyrllist;
          this.$store.commit("filter", filter);
      } 
    },    

    add: function() {
         this.saveFilter();
          router.push({name: 'hrm.payrollfrm'});
    },
    edit: function() {
        if (this.model.payrollkey) {
         this.saveFilter();
          router.push({name: 'hrm.payrollfrm', params: { payrollkey: this.model.payrollkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.payrollkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      await payroll.remove(this.model);
      this.refresh();
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await payroll.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error), 'Error Info',10000);
            }
        }
    },
    payrollprocess: async function()
    {
      if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "Error Info");
        } else {
            this.process_Confirm = false;
            this.isLoading=true;
            this.tblData.paymentdate=this.frmdata.payrolldate;
            try {
                this.frmdata.tahunbulan=moment(this.frmdata.payrolldate).format('YYYYMM'); 
                // this.tblData.tahunbulan=moment(this.frmdata.payrolldate).format('YYYYMM'); 
                const response = await payroll.process(this.frmdata);
                this.isLoading=false;   
                this.refresh() ;
            } catch (error) {
                this.isLoading=false;
                this.process_Confirm = true;
                if (error.sql) {
                    toastr.error(error.sql,'Error Info',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'Error Info',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'Error Info',10000);
                  }
                }
            }
        } 
    },
    payrollcancel: async function()
    {
      if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "Error Info");
        } else {
            this.process_Confirm = false;
            this.isLoading=true;
            this.tblData.paymentdate=this.frmdata.payrolldate;
            try {
                this.frmdata.tahunbulan=moment(this.frmdata.payrolldate).format('YYYYMM'); 
                const response = await payroll.cancel(this.frmdata);
                this.isLoading=false;   
                this.refresh() ;
            } catch (error) {
                this.isLoading=false;
                this.process_Confirm = true;
                if (error.sql) {
                    toastr.error(error.sql,'Error Info',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'Error Info',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'Error Info',10000);
                  }
                }
            }
        } 
    },
    email: async function()
    {
      if (this.model) {
          this.isLoading=true;
          try {
              await payroll.email(this.model);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    print: async function()
    {
      if (this.model) {
          try {
              this.showReport=true;
              this.reportUrl= await payroll.print(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },

    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
